export default {
  exam: {
    id: '',
    degreeId: '',
    degreeCode: '',
    subjectGroupId: '',
    subjectGroupCode: '',
    subjectId: '',
    teacherId: '',
    teacherCode: '',
    QuestionQty: null,
    QuestionMultiQty: null,
    QuestionTrueFalseQty: null,
  },
  exams: [],
  processing: false,
  error: null,
  success: null,
}



